module.exports = __webpack_public_path__ + "img/dianti.cd53ca26.jpg";